/* Nutraflo store scripts (claude code v7.2).
   One module for every nfs- section: tabs, pack tiles + price bar, gallery, quantity,
   sticky add-to-cart, add-to-cart into Horizon's cart drawer, reels sound, brand video, film pause. */

const NF = {
  cur: '₹',
  money(cents) {
    const v = Math.round(cents) / 100;
    return NF.cur + v.toLocaleString('en-IN', { minimumFractionDigits: v % 1 ? 2 : 0, maximumFractionDigits: 2 });
  },
};

/* ---------- add to cart (feeds Horizon's cart drawer, falls back to normal form post) ---------- */
let CartEvent = null;
import('@shopify/events')
  .then((m) => { CartEvent = m.CartLinesUpdateEvent; })
  .catch(() => {});

async function nfAddToCart(form, button) {
  const fd = new FormData(form);
  const id = fd.get('id');
  const quantity = Number(fd.get('quantity') || 1);
  if (!id) return false;

  const sectionIds = [...document.querySelectorAll('cart-items-component')]
    .map((el) => el.dataset.sectionId)
    .filter(Boolean);
  if (sectionIds.length) fd.append('sections', sectionIds.join(','));

  let deferred = null;
  if (CartEvent) {
    deferred = CartEvent.createPromise();
    form.dispatchEvent(
      new CartEvent({
        action: 'add',
        context: 'product',
        lines: [{ merchandiseId: String(id), quantity }],
        promise: deferred.promise,
      })
    );
  }

  button?.setAttribute('aria-busy', 'true');
  try {
    const routes = window.Theme?.routes || {};
    const res = await fetch(routes.cart_add_url || '/cart/add', {
      method: 'POST',
      body: fd,
      headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/javascript' },
    }).then((r) => r.json());

    const cart = await fetch((routes.cart_url || '/cart') + '.json', { headers: { Accept: 'application/json' } }).then((r) => r.json());

    if (deferred) {
      deferred.resolve({
        cart: CartEvent.createCartFromAjaxResponse(cart),
        detail: {
          items: cart.items,
          source: 'nfs',
          sourceId: form.id || 'nfs',
          itemCount: quantity,
          productId: form.dataset.productId,
          sections: res.sections,
          didError: Boolean(res.status),
        },
      });
    }

    if (res.status) {
      nfToast(form, res.description || res.message || 'Could not add to cart');
      return true;
    }
    if (!deferred) window.location.href = (routes.cart_url || '/cart');
    return true;
  } catch (e) {
    deferred?.reject(e);
    return false;
  } finally {
    button?.removeAttribute('aria-busy');
  }
}

function nfToast(form, text) {
  let el = form.querySelector('.nfs-err');
  if (!el) {
    el = document.createElement('p');
    el.className = 'nfs-err';
    el.setAttribute('role', 'alert');
    form.append(el);
  }
  el.textContent = text;
  setTimeout(() => el.remove(), 5000);
}

document.addEventListener('submit', async (e) => {
  const form = e.target.closest('form[data-nfs-cart]');
  if (!form) return;
  e.preventDefault();
  const ok = await nfAddToCart(form, e.submitter);
  if (!ok) form.submit();
});

/* ---------- tabs ---------- */
if (!customElements.get('nfs-tabs')) {
  customElements.define(
    'nfs-tabs',
    class extends HTMLElement {
      connectedCallback() {
        const tabs = [...this.querySelectorAll('[role="tab"]')];
        const pick = (t) =>
          tabs.forEach((x) => {
            const on = x === t;
            x.setAttribute('aria-selected', on);
            x.tabIndex = on ? 0 : -1;
            const p = document.getElementById(x.getAttribute('aria-controls'));
            if (p) p.hidden = !on;
          });
        tabs.forEach((t, i) => {
          t.addEventListener('click', () => pick(t));
          t.addEventListener('keydown', (e) => {
            const d = e.key === 'ArrowRight' ? 1 : e.key === 'ArrowLeft' ? -1 : 0;
            if (!d) return;
            const n = tabs[(i + d + tabs.length) % tabs.length];
            n.focus();
            pick(n);
          });
        });
      }
    }
  );
}

/* ---------- product page: pack tiles, price bar, ship bar, gallery, sticky bar ---------- */
if (!customElements.get('nfs-product')) {
  customElements.define(
    'nfs-product',
    class extends HTMLElement {
      connectedCallback() {
        const root = this;
        if (root.dataset.cur) NF.cur = root.dataset.cur;
        const threshold = Number(root.dataset.threshold || 69900);
        const qtyIn = root.querySelector('[data-nfs-qty]');
        const idIn = root.querySelector('[data-nfs-id]');
        const ship = root.querySelector('[data-nfs-shipbox]');
        const q = () => Math.max(1, parseInt(qtyIn?.value, 10) || 1);
        const set = (sel, v) => root.querySelectorAll(sel).forEach((n) => (n.textContent = v));

        const render = () => {
          const r = root.querySelector('input[name="nfs-pack"]:checked');
          if (!r) return;
          if (idIn) idIn.value = r.value;
          const cents = +r.dataset.cents;
          const mrp = +r.dataset.mrp || 0;
          const units = +r.dataset.units || 0;
          set('[data-nfs-price]', NF.money(cents));
          const mrpEl = root.querySelector('[data-nfs-mrp]');
          const saveEl = root.querySelector('[data-nfs-save]');
          const savedLine = root.querySelector('[data-nfs-savedline]');
          if (mrp > cents) {
            if (mrpEl) { mrpEl.hidden = false; mrpEl.textContent = NF.money(mrp); }
            if (saveEl) { saveEl.hidden = false; saveEl.textContent = Math.round((1 - cents / mrp) * 100) + '% off'; }
            if (savedLine) savedLine.hidden = false;
            set('[data-nfs-saved]', NF.money((mrp - cents) * q()));
          } else {
            if (mrpEl) mrpEl.hidden = true;
            if (saveEl) saveEl.hidden = true;
            if (savedLine) savedLine.hidden = true;
          }
          const perEl = root.querySelector('[data-nfs-perline]');
          if (perEl) {
            perEl.hidden = !units;
            if (units) set('[data-nfs-per]', NF.money(cents / units));
          }
          const total = cents * q();
          set('[data-nfs-total]', NF.money(total));
          const atc = root.querySelectorAll('[data-nfs-atc]');
          const soldOut = r.dataset.available === 'false';
          atc.forEach((b) => {
            b.disabled = soldOut;
            const label = b.querySelector('[data-nfs-atc-label]');
            if (label) label.textContent = soldOut ? b.dataset.soldout : b.dataset.add;
          });
          if (ship) {
            const msg = ship.querySelector('[data-nfs-ship]');
            const bar = ship.querySelector('[data-nfs-bar]');
            if (msg) {
              msg.innerHTML =
                total >= threshold
                  ? '<b>' + ship.dataset.free + '</b>'
                  : ship.dataset.more.replace('[amount]', '<b>' + NF.money(threshold - total) + '</b>');
            }
            if (bar) bar.style.width = Math.min(100, (total / threshold) * 100) + '%';
          }
          // switch gallery to the variant image when it has one
          const vimg = r.dataset.mediaIndex;
          if (vimg !== undefined && vimg !== '' && this.go) this.go(+vimg);
        };

        root.querySelectorAll('input[name="nfs-pack"]').forEach((r) => r.addEventListener('change', render));
        root.querySelectorAll('[data-q]').forEach((b) =>
          b.addEventListener('click', () => {
            qtyIn.value = Math.max(1, q() + +b.dataset.q);
            render();
          })
        );
        qtyIn?.addEventListener('input', render);

        // gallery
        const thumbs = [...root.querySelectorAll('[data-nfs-thumb]')];
        const mainImg = root.querySelector('[data-nfs-main]');
        const count = root.querySelector('[data-nfs-count]');
        let cur = 0;
        this.go = (i) => {
          if (!thumbs.length || !mainImg) return;
          cur = (i + thumbs.length) % thumbs.length;
          const b = thumbs[cur];
          mainImg.src = b.dataset.src;
          mainImg.srcset = b.dataset.srcset || '';
          mainImg.alt = b.dataset.alt || '';
          thumbs.forEach((x) => x.setAttribute('aria-current', x === b));
          if (count) count.textContent = cur + 1 + ' / ' + thumbs.length;
          b.scrollIntoView({ block: 'nearest', inline: 'nearest' });
        };
        thumbs.forEach((b, i) => b.addEventListener('click', () => this.go(i)));
        root.querySelectorAll('[data-nav]').forEach((b) => b.addEventListener('click', () => this.go(cur + +b.dataset.nav)));
        const main = root.querySelector('.nfs-gal__main');
        let sx = null;
        main?.addEventListener('touchstart', (e) => { sx = e.touches[0].clientX; }, { passive: true });
        main?.addEventListener('touchend', (e) => {
          if (sx === null) return;
          const dx = e.changedTouches[0].clientX - sx;
          if (Math.abs(dx) > 40) this.go(cur + (dx < 0 ? 1 : -1));
          sx = null;
        });

        // sticky bar on phones
        const sticky = root.querySelector('[data-nfs-sticky]');
        const atcMain = root.querySelector('.nfs-buy [data-nfs-atc]');
        if (sticky && atcMain) {
          const io = new IntersectionObserver(([en]) => {
            sticky.hidden = en.isIntersecting || en.boundingClientRect.top > 0;
          });
          io.observe(atcMain);
          sticky.querySelector('button')?.addEventListener('click', () => {
            root.querySelector('form[data-nfs-cart]')?.requestSubmit();
          });
        }
        render();
      }
    }
  );
}

/* ---------- reels: play when on screen, tap for sound ---------- */
document.querySelectorAll('.nfs-reel__el').forEach((v) => {
  if (!(v instanceof HTMLVideoElement)) return;
  const io = new IntersectionObserver(([en]) => (en.isIntersecting ? v.play().catch(() => {}) : v.pause()), { threshold: 0.6 });
  io.observe(v);
});
document.addEventListener('click', (e) => {
  const b = e.target.closest('.nfs-reel__sound');
  if (!b) return;
  const v = b.closest('.nfs-reel__v')?.querySelector('video');
  const on = b.getAttribute('aria-pressed') !== 'true';
  b.setAttribute('aria-pressed', on);
  b.setAttribute('aria-label', on ? b.dataset.off : b.dataset.on);
  if (v) v.muted = !on;
});

/* ---------- brand video: click to load ---------- */
document.addEventListener('click', (e) => {
  const b = e.target.closest('.nfs-vid__play');
  if (!b) return;
  const wrap = b.parentElement;
  const tpl = wrap.querySelector('template');
  if (!tpl) return;
  b.replaceWith(tpl.content.cloneNode(true));
  wrap.querySelector('video')?.play().catch(() => {});
});

/* ---------- footer film pause ---------- */
document.addEventListener('click', (e) => {
  const b = e.target.closest('[data-nfs-pause]');
  if (!b) return;
  const film = b.closest('.nfs-film');
  const paused = b.getAttribute('aria-pressed') === 'true';
  film?.querySelectorAll('video').forEach((v) => (paused ? v.play() : v.pause()));
  film?.classList.toggle('is-paused', !paused);
  b.setAttribute('aria-pressed', !paused);
  b.textContent = paused ? b.dataset.pause : b.dataset.play;
});
